import React from "react";
import "./index.css";
import { render } from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "./App";
import { ContactPage } from "./pages/Contact";
render(<BrowserRouter data-id="element-126">
    <Routes data-id="element-127">
      <Route path="/" element={<App data-id="element-129" />} data-id="element-128" />
      <Route path="/contact" element={<ContactPage data-id="element-131" />} data-id="element-130" />
    </Routes>
  </BrowserRouter>, document.getElementById("root"));